import { DATA_ROWS } from "../../../../components/CustomTable";
import {
  errorNotifier,
  successNotifier,
} from "../../../../components/NotificationHandler";
import http, { AUTH_ROUTES } from "../../../../services/api";

export const getAllCheckouts = async (
  
  setLoading,
  setAllCheckouts,
  setTotal,
  skip = 0
) => {
  const page = skip * DATA_ROWS.LIMIT;
  try {
    const {
      data: {
        result: { data },
      },
    } = await http.get(AUTH_ROUTES.MANAGER_GET_CHECKOUTS);

    setAllCheckouts(data);
    // console.log(data);
    setTotal && setTotal(data?.length);
  } catch (e) {
    console.log(e?.response?.result || "Error fetching checkouts");
    setLoading(false);
  } finally {
    setLoading(false);
  }
};

export const getSingleCheckout = async (
  userId,
  checkoutId,
  setLoading,
  setCheckout
) => {
  try {
    const {
      data: {
        result: { data },
      },
    } = await http.get(AUTH_ROUTES.MANAGER_GET_SINGLE_CHECKOUT(userId, checkoutId));

    setCheckout(data);
  } catch (e) {
    errorNotifier(e?.response?.result || "Error fetching checkout details");
    setLoading(false);
  } finally {
    setLoading(false);
  }
};